import { Button, Icon } from "@mui/material";
import { useEffect, useState } from "react";


import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import BlockIcon from '@mui/icons-material/Block';
import SaveIcon from '@mui/icons-material/Save';
import DownloadIcon from '@mui/icons-material/Download';
import UploadIcon from '@mui/icons-material/Upload';
import CheckIcon from '@mui/icons-material/Check';
import ClearIcon from '@mui/icons-material/Clear';
import RemoveIcon from '@mui/icons-material/Remove';
import LoginIcon from '@mui/icons-material/Login';
import LockResetIcon from '@mui/icons-material/LockReset';
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import RefreshIcon from '@mui/icons-material/Refresh';
import PriorityHighIcon from '@mui/icons-material/PriorityHigh';

export type ButtonIconType = "add" | "pencil" | "arrow_back" | "block" | "save" | "download" | "upload" | "check" | "clear" | "remove" | "back" | "login" | "lock_reset" | "restart_alt" | "access_time" | "refresh" | "priority_high";
export type ButtonVariant = 'inherit' | 'primary' | 'secondary' | 'success' | 'error' | 'info' | 'warning';

export function getMaterialIcon(name: string) {
    switch (name) {
        case 'add':
            return <AddIcon />;

        case 'pencil':
            return <EditIcon />;

        case 'arrow_back':
        case 'back':
            return <ArrowBackIcon />;

        case 'block':
            return <BlockIcon />;

        case 'save':
            return <SaveIcon />;

        case 'download':
            return <DownloadIcon />;

        case 'upload':
            return <UploadIcon />;

        case 'check':
            return <CheckIcon />;

        case 'clear':
            return <ClearIcon />;

        case 'remove':
            return <RemoveIcon />;

        case 'login':
            return <LoginIcon />;

        case 'lock_reset':
            return <LockResetIcon />;

        case 'restart_alt':
            return <RestartAltIcon />;

        case 'access_time':
            return <AccessTimeIcon />;

        case 'refresh':
            return <RefreshIcon />;

        case 'priority_high':
            return <PriorityHighIcon />;

        default:
            return null;
    }
}

export const StandardButton = (params: {
    icon?: ButtonIconType,
    children: React.ReactNode,
    onClick?: (event: any) => void;
    variant?: ButtonVariant,
    saving?: boolean,
    loading?: boolean,
    disabled?: boolean,
    type?: "button" | "submit",
    // key?: string
}) => {

    const iconStyle = { "fontSize": '1.4rem !important' };

    return (
        <Button fullWidth disabled={params.disabled || params.loading || params.saving} color={params.variant || "primary"} type={params.type || "button"} sx={{ fontSize: '0.9rem !important' }} variant="contained" disableElevation
            startIcon={<>{getMaterialIcon('save')}</>} onClick={params.onClick}>

            {(params.saving !== true && params.loading !== true && params.children) && <>{params.children}</>}

            {(params.saving === true) &&
                <>Saving<LoadingDots /></>
            }

            {(params.loading === true) &&
                <>Loading<LoadingDots /></>
            }
        </Button>

    );
}

const LoadingDots = () => {
    const [loadingStatus, setLoadingStatus] = useState("..");

    useEffect(() => {
        const intervalId = setInterval(() => {
            setLoadingStatus(ls => ls.length >= 5 ? ".." : ls + ".");
        }, 400);

        return () => clearInterval(intervalId);
    }, []);

    return <>{`${loadingStatus}`}</>;
};